import React from "react";
import api from "./Api";

export const signUp = (user) =>
  api.post("/user/registration", { ...user }).then((res) => res.data);

export const updateUserInfos = (user) =>
  api.put("/user/update", { ...user }).then((res) => res.data);

export const logIn = (credentials) =>
  api.post("/login", { ...credentials }).then((res) => res.data);

export const logOut = () => api.post("/logout").then((res) => res.data);

export const getMe = () => api.get("/me").then((res) => res.data);

export const saveAvatar = (profileImage) =>
  api.post("/user/avatar", profileImage).then((res) => res.data);

export const sendResetPasswordEmail = (email) =>
  api.post("/reset-password", { email: email }).then((res) => res.data);

export const storeTokenInSession = (token) =>
  api
    .post("/reset-password/store-token", { token: token })
    .then((res) => res.data);

export const changePassword = (password) =>
  api
    .post("/reset-password/change", { password: password })
    .then((res) => res.data);

// todo delete this api because not use
export const resendResetPasswordEmail = (email) =>
  api
    .post("/reset-password/resend-email", { email: email })
    .then((res) => res.data);

export const createProduct = (product) =>
  api.post("/product/new", product).then((res) => res.data);

export const updateProduct = (product) =>
  api.post("/product/update", product).then((res) => res.data);

export const deleteProduct = (ids) =>
  api.delete("/product/delete", { data: { ids: ids } }).then((res) => res.data);

export const getCelebrities = () =>
  api.get("/celebrities").then((res) => res.data);

export const getOrderType = () =>
  api.get("/order-type").then((res) => res.data);

export const cbPayment = (requestBody) =>
  api.post("/payment/cb", requestBody).then((res) => res.data);

export const updateOrder = (requestBody, orderRef) =>
  api.put(`/order/update/${orderRef}`, requestBody).then((res) => res.data);

export const createOrder = (requestBody) =>
  api.post("/order/create-order", requestBody).then((res) => res.data);

export const confirmOrder = (ref, transactionId) =>
  api
    .post(`/order/confirm-order/${ref}?transaction_id=${transactionId}`)
    .then((res) => res.data);

export const getOrdersByUser = () => api.get("/orders").then((res) => res.data);

export const uploadVideoChunk = (body) =>
  api.post("/order/upload/chunk", body).then((res) => res.data);

export const finalizeUploadChunk = (body) =>
  api.post("/order/upload/finalize", body).then((res) => res.data);

export const getVideoProcessingStatus = (orderId) =>
  api.get(`/order/${orderId}/status`).then((res) => res.data);

export const getDedicace = (orderRef, email) =>
  api
    .get(`/order/dedicace-file/${orderRef}/${btoa(email)}`)
    .then((res) => res.data);

export const getProductCategories = () =>
  api.get("/product/categories").then((res) => res.data);

export const getCelebrityCategories = () =>
  api.get("/celebrity/categories").then((res) => res.data);

export const getTerms = () => api.get("/terms").then((res) => res.data);
export const getFaq = () => api.get("/faqs").then((res) => res.data);
export const confirmEmailAddress = (token) =>
  api.get("/confirm-email/" + token).then((res) => res.data);

export const getBalance = () => api.get("/balance").then((res) => res.data);
export const getPayments = (id) =>
  api.get("/celebrity-payment/" + id).then((res) => res.data);

export const getFeatureToggle = () =>
  api.get("/feature-toggle").then((res) => res.data);
